/* eslint-disable max-lines-per-function */
import React from "react";

import { useFormikContext } from "formik";

import { Grid } from "@mui/material";

import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { TosCheckbox } from "components/haven-design/form/checkbox";

import { SubmitButton } from "components/buttons";

import { Values } from "../pages/form";

const LinkAppForm: React.FC = () => {
  const { values: { email }, isSubmitting, isValid } = useFormikContext<Values>();

  return (
    <Grid container spacing={2}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <InputWithErrorLabel label="First Name" name="firstName" type="text" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <InputWithErrorLabel label="Last Name" name="lastName" type="text" />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <InputWithErrorLabel label="Mobile Phone" name="phone" type="text" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <InputWithErrorLabel label="Email" name="email" type="text" />
        </Grid>
      </Grid>

      {email && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <InputWithErrorLabel label="Create a Password" name="password" type="password" />
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <InputWithErrorLabel label="Link Code" name="linkCode" type="text" />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }} style={{ paddingTop: 15 }}>
          <TosCheckbox name="terms" />
        </Grid>
      </Grid>

      <Grid container>
        <Grid style={{ paddingTop: 15 }}>
          <SubmitButton text="Submit" disabled={!isValid} loadingText="Sending" isLoading={isSubmitting} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LinkAppForm;
